"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const computeTransition_1 = require("../ControlStyleFormaters/shared/computeTransition");
const executeTransition = (speed) => new Promise((resolve) => {
    setTimeout(() => resolve(), (0, computeTransition_1.computeTransitionSpeed)(speed));
});
exports.default = executeTransition;
